import { MD5 } from 'crypto-js';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LeftArrowIcon, RightArrowIcon } from '../../../../../utils/SVGIcon';
import cn from '../../../../../utils/cn';
import UserSection from './UserSection';

export function RightArrow() {
    return (
        <span className=" block h-4 w-4">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
            >
                <path
                    d="M6.26424 14.5248C5.89006 14.9101 5.70298 15.1028 5.46906 15.1082C5.46036 15.1084 5.45166 15.1084 5.44296 15.1082C5.20904 15.1028 5.02196 14.9101 4.64779 14.5248C4.29321 14.1596 4.11591 13.977 4.11098 13.7526C4.11079 13.7442 4.11079 13.7358 4.11098 13.7274C4.11592 13.503 4.29321 13.3204 4.6478 12.9552L8.20078 9.29616C8.56612 8.91992 8.74878 8.7318 8.74878 8.50001C8.74878 8.26823 8.56612 8.08011 8.20078 7.70386L4.6478 4.0448C4.29321 3.67963 4.11592 3.49704 4.11098 3.2726C4.11079 3.26422 4.11079 3.25584 4.11098 3.24746C4.11591 3.02302 4.29321 2.84043 4.64779 2.47525C5.02196 2.08989 5.20904 1.89722 5.44296 1.89187C5.45166 1.89167 5.46036 1.89167 5.46906 1.89187C5.70298 1.89721 5.89006 2.08989 6.26424 2.47523L11.3413 7.70386C11.7066 8.08011 11.8893 8.26823 11.8893 8.50001C11.8893 8.7318 11.7066 8.91992 11.3413 9.29616L6.26424 14.5248Z"
                    fill="#1B1B1F"
                />
            </svg>
        </span>
    );
}

function HeaderRightCol() {
    // const { pathname } = useLocation();
    // const pathAr = pathname.split('/').slice(1);
    // last item empty string if path ends with '/'
    // if (!pathAr[pathAr.length - 1]) pathAr.pop();

    const location = useLocation();
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    useEffect(() => {
        const pathSegments = location.pathname.split('/').filter((segment) => segment !== '');

        const breadcrumbsArray = pathSegments.map((segment, index) => {
            const path = `/${pathSegments.slice(0, index + 1).join('/')}`;
            let clickable = false;
            if (pathSegments.length === 3) {
                clickable = true;
            }
            return { segment, path, clickable };
        });
        setBreadcrumbs(breadcrumbsArray);
    }, [location.pathname]);

    const { history } = window;

    return (
        <div className="header_right-side">
            <div className="flex items-center justify-center gap-4 mr-4">
                <button type="button" onClick={() => history.go(-1)} className="size-7">
                    <LeftArrowIcon />
                </button>
                <button type="button" onClick={() => history.go(1)} className="size-7 text-primary">
                    <RightArrowIcon />
                </button>
            </div>
            <div className="hidden lg:flex flex-row gap-x-2 font-medium text-2xl text-primary capitalize">
                {breadcrumbs.map((breadcrumb, index) => {
                    if (Number(breadcrumb.segment)) return null;
                    return (
                        <span
                            key={MD5(breadcrumb.path)}
                            className={cn('inline-flex items-center gap-2', {
                                'pointer-events-none cursor-default':
                                    index === breadcrumbs.length - 1,
                                'a pointer-events-none': index === 0,
                                'b pointer-events-auto': breadcrumb?.clickable && index === 0,
                                'a underline': index !== 0,
                                'b underline': breadcrumb?.clickable && index === 0,
                                // if last item, no underline
                                'no-underline': index === breadcrumbs.length - 1
                            })}
                        >
                            <Link to={breadcrumb?.path} className="whitespace-nowrap">
                                {breadcrumb?.segment}
                            </Link>
                            {index !== breadcrumbs.length - 1 && <RightArrow />}
                        </span>
                    );
                })}
            </div>
            <UserSection />
        </div>
    );
}

export default HeaderRightCol;
